<!--
 * @Descripttion: 重置密码
 * @FilePath: /mall-wap-vue/src/views/login/forgot/reset/index.vue
 * @Author: 张兴业
 * @Date: 2020-10-10 15:39:20
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-12-25 11:05:05
-->
<template>
  <div class="reset">
    <nav-bar @back="back" />
    <page-title title="重新设置密码" />
    <div class="login_con">
      <van-form ref="login" @submit="onSubmit">
        <!-- 新密码 -->
        <new-password-field v-model="newPassword" />
        <!-- 确认密码 -->
        <confirm-password-field v-model="confirmPassword" />
        <div class="actions">
          <!-- 登录按钮 -->
          <van-button
            block
            type="info"
            native-type="submit"
            class="login_submit"
            :disabled="disabledBtn"
          >
            确认
          </van-button>
        </div>
        <div v-if="errorMsg" class="login_error">
          {{ errorMsg }}
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
const NavBar = () => import("../components/NavBar");
const PageTitle = () => import("../../components/PageTitle");
const NewPasswordField = () => import("./components/NewPasswordField");
const ConfirmPasswordField = () => import("./components/ConfirmPasswordField");

export default {
  components: {
    NavBar,
    PageTitle,
    NewPasswordField,
    ConfirmPasswordField
  },
  data() {
    return {
      newPassword: "",
      confirmPassword: "",
      errorMsg: ""
    };
  },
  computed: {
    disabledBtn() {
      if (
        this.newPassword.length >= 6 &&
        this.newPassword.length <= 12 &&
        this.confirmPassword.length >= 6 &&
        this.confirmPassword.length <= 12 &&
        this.newPassword === this.confirmPassword
      ) {
        return false;
      }
      return true;
    }
  },
  methods: {
    back() {
      this.$router.go("-1");
    },
    onSubmit(values) {
      const { newPassword, confirmPassword } = values;
      if (newPassword !== confirmPassword) {
        this.errorMsg = "两次输入密码不一致";
        return;
      }
      const { phone, code } = this.$route.query;
      this.$store
        .dispatch("mine/changePassword", {
          params: {
            phone,
            code,
            newPassword,
            kind: "ChangePwd"
          }
        })
        .then(() => {
          this.$toast("密码已重置");
          this.$router.go(-2);
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.reset {
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .login_con {
    margin: 72px 38px;
  }

  .actions {
    margin-top: 38px;

    .login_submit {
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border: none;
      font-size: 16px;
      height: 48px;
      line-height: 48px;
    }
  }

  .login_error {
    padding: 4px;
    color: #ff0000;
    font-size: 12px;
    text-align: center;
  }
}
</style>
